import { assertResolvedAtsNotHttpError } from '@/api/ats/atsEnvelope';
import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';

export interface UserGroupUser {
  id: number;
  name: string;
  avatar_url?: string;
  email: string;
}

export interface UserGroupDetail {
  id: number;
  name: string;
  category: string;
  users: UserGroupUser[];
}

interface GetUserGroupApiResponse {
  data: UserGroupDetail;
  errors: string[];
}

const toGroupId = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') return undefined;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) && n > 0 ? n : undefined;
};

export const useGetUserGroup = ({
  id: rawId,
}: {
  id: number | string | undefined | null;
}) => {
  const groupId = toGroupId(rawId);

  const query = useQuery<GetUserGroupApiResponse, Error>({
    queryKey: ['user-group', groupId],
    queryFn: async () => {
      const res = await http.get<GetUserGroupApiResponse>(
        `user_groups/${groupId}`
      );
      assertResolvedAtsNotHttpError(res);
      return res as unknown as GetUserGroupApiResponse;
    },
    staleTime: 0,
    enabled: groupId !== undefined,
  });

  const userGroup = query.data?.data;
  const uiError = query.data?.errors ?? [];

  return { userGroup, uiError, ...query };
};
